import { Field, Form, Formik } from "formik";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FormField } from "@/components/common";
import { profileSchema } from "../utils";

const FieldInput = ({ label, name, type = "text", required, validator }) => (
  <Field name={name} validate={validator}>
    {({ field, meta }) => (
      <FormField
        label={label}
        type={type}
        {...field}
        error={meta.touched && meta.error}
        required={required}
      />
    )}
  </Field>
);

const ProfileSection = ({
  initialValues,
  onSubmit,
  uniqueUsernameValidator,
  uniqueEmailValidator,
}) => (
  <Card className="border-border/70 h-[440px] flex flex-col">
    <CardHeader>
      <CardTitle className="text-primary">User Information</CardTitle>
    </CardHeader>
    <CardContent className="flex flex-col flex-1">
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={profileSchema}
        onSubmit={onSubmit}
      >
        {({ isSubmitting }) => (
          <Form className="flex flex-col flex-1">
            <div className="space-y-4">
              <FieldInput
                label="Username"
                name="username"
                required
                validator={uniqueUsernameValidator}
              />
              <FieldInput label="Display Name" name="name" required />
              <FieldInput
                label="Email"
                name="email"
                type="email"
                required
                validator={uniqueEmailValidator}
              />
              <Field name="company">
                {({ field }) => (
                  <FormField label="Company" disabled {...field} />
                )}
              </Field>
            </div>
            <div className="mt-auto pt-6 flex justify-end">
              <Button type="submit" disabled={isSubmitting}>
                {isSubmitting ? "Saving..." : "Save Changes"}
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </CardContent>
  </Card>
);

export default ProfileSection;
